import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import Button from '@components/Button'
import { formatDateTime } from '@atheneum/api/dist/lib'
import propTypes from 'prop-types'
import { scheduleApi } from '@atheneum/api'
import { Formik, Form, Field } from 'formik'
import get from 'lodash/get'
import Input from '@components/Form/Input'
import yup from 'yup'
import InfoBox from '@components/InfoBox'
import FormError from '@components/FormError'
import FormLoader from '@components/FormLoader'
import Spinner from '@components/spinner'
import Radio from '@components/Radio'

class ZoomMeeting extends Component {
  static propTypes = {
    modalStore: propTypes.object,
    userStore: propTypes.object,
    growlStore: propTypes.object,
    eplModel: propTypes.object,
    matchedZoomMeetings: propTypes.array,
    epl: propTypes.object,
    project: propTypes.object,
    schedule: propTypes.object,
    openModalOnClose: propTypes.string
  }

  static defaultProps = {
    hideButtons: true
  }

  state = {
    error: null,
    zoomMeeting: get(this.props, 'matchedZoomMeetings.0.id', null)
  }

  attachZoomMeeting = async () => {
    const { schedule, growlStore } = this.props
    try {
      await scheduleApi.attachZoomMeeting(schedule.id, this.state.zoomMeeting)
      this.handleAfterSubmit()
    } catch (error) {
      growlStore.showError(error)
      this.setState({
        error
      })

      console.error('error', error)
    }
  }

  sumbmitMeetingForm = async (values, actions) => {
    const { schedule, growlStore } = this.props

    try {
      this.setState({
        error: null
      })

      const meetingData = {
        topic: values.topic,
        zoomMeetingId: schedule.zoomMeeting && schedule.zoomMeeting.id,
        startTime: schedule.startTime,
        duration: schedule.duration,
        password: this.props.epl.id
      }

      await scheduleApi.saveZoomMeeting(schedule.id, meetingData)
      actions.setSubmitting(false)
      this.handleAfterSubmit()
    } catch (error) {
      actions.setSubmitting(false)
      growlStore.showError(error)
      this.setState({
        error
      })

      console.error('error', error)
    }
  }

  returnToScheduleModal = () => {
    this.props.modalStore.show({
      type: 'SCHEDULE_CALENDAR_MODAL',
      props: {
        ...this.props.modalStore.props,
        eplModel: this.props.eplModel,
        epl: this.props.epl,
        project: this.props.project
        // projectStore: this.props.projectStore
      }
    })
  }

  handleAfterSubmit = async () => {
    const { modalStore, openModalOnClose, epl, eplModel } = this.props

    if (!openModalOnClose) {
      this.returnToScheduleModal()
      return
    }

    const scheduleInfo = await scheduleApi.getScheduleInfo(this.props.schedule.id)

    return modalStore.show({
      type: openModalOnClose,
      props: {
        ...modalStore.props,
        epl: epl,
        eplModel: eplModel,
        schedule: scheduleInfo,
        closeAfter: true
      }
    })
  }

  getInitialFormValues = () => {
    const { epl, schedule, project } = this.props
    const meetingAlreadyCreated = !!schedule.zoomMeeting
    const defaultTopic = epl.hideExpertName
      ? 'Atheneum call'
      : `Atheneum: ${project.projectName} - ${epl.segment.name} - ${epl.expert.title
      } ${epl.expert.fullName}`
    const topic = meetingAlreadyCreated
      ? schedule.zoomMeeting.topic
      : defaultTopic

    return { topic }
  }

  getFormValidationSchema = () => {
    return yup.object().shape({
      topic: yup.string().required('Call topic is required')
    })
  }

  renderLoader = () => {
    if (!this.loading) return null
    return (
      <div className='expert-form__loading-overlay'>
        <Spinner center />
      </div>
    )
  }

  renderTitle = ({ schedule, openModalOnClose }) => {
    if (schedule.zoomMeeting) {
      return <h1>Edit Zoom meeting</h1>
    } else {
      const title = openModalOnClose
        ? 'Create Zoom Meeting before sending Invite'
        : 'Create Zoom Meeting'
      return <h1>{title}</h1>
    }
  }

  renderUserInfo = (schedule, user) => {
    const userLabel = schedule.zoomMeeting
      ? 'Created by (Atheneum user)'
      : 'Current user (Atheneum)'

    const creatorUser = schedule.zoomMeetingCreator
      ? `${schedule.zoomMeetingCreator.fullName} (${schedule.zoomMeetingCreator.email
      })`
      : 'Creator user missing!'

    const userData = schedule.zoomMeeting
      ? creatorUser
      : `${user.fullName} (${user.email})`

    const userOnPlatform = (
      <div className='expert-form__input-group'>
        <label className='expert-form__label'>{userLabel}</label>
        <div className='expert-form__input-wrapper expert-form__input-wrapper--label'>
          {userData}
        </div>
      </div>
    )

    const zoomUserLabel = schedule.zoomMeeting
      ? 'Created by (Zoom User)'
      : 'Call will be created by (Zoom User)'

    let zoomUserInfo
    if (schedule.zoomMeeting && schedule.zoomMeeting.creator) {
      zoomUserInfo = `${schedule.zoomMeeting.creator.first_name} ${schedule.zoomMeeting.creator.last_name
        } (${schedule.zoomMeeting.creator.email})`
    } else if (!schedule.zoomMeeting && schedule.zoomUser) {
      zoomUserInfo = `${schedule.zoomUser.first_name} ${schedule.zoomUser.last_name
        } (${schedule.zoomUser.email})`
    } else {
      zoomUserInfo = `Zoom user missing!`
    }

    const zoomUser = (
      <div className='expert-form__input-group'>
        <label className='expert-form__label'>{zoomUserLabel}</label>
        <div className='expert-form__input-wrapper expert-form__input-wrapper--label'>
          {zoomUserInfo}
        </div>
      </div>
    )

    return (
      <div className='m-t-lg'>
        {userOnPlatform}
        {zoomUser}
      </div>
    )
  }

  renderMeetingPassword = () => {
    const password = this.props.epl.id
    return (
      <div className='m-t-lg'>
        <div className='expert-form__input-group'>
          <label className='expert-form__label'>Meeting Password</label>
          <div className='expert-form__input-wrapper expert-form__input-wrapper--label'>
            {password}
          </div>
        </div>
      </div>
    )
  }

  renderMeetingInfo = schedule => {
    if (!schedule.zoomMeeting) {
      const scheduleStartTime = `${formatDateTime(schedule.startTime)} (${schedule.duration
        } min)`
      return (
        <div className='expert-form__input-group'>
          <label className='expert-form__label'>
            Call start time (duration)
          </label>
          <div className='expert-form__input-wrapper expert-form__input-wrapper--label'>
            {scheduleStartTime}
          </div>
        </div>
      )
    }

    const startTime = `${formatDateTime(schedule.zoomMeeting.start_time)} (${schedule.zoomMeeting.duration
      } min)`

    return (
      <div className="m-t-lg">
        <div className="expert-form__input-group">
          <label className="expert-form__label">
            Call start time (duration)
          </label>
          <div className="expert-form__input-wrapper expert-form__input-wrapper--label">
            {startTime}
          </div>
        </div>

        <div className="expert-form__input-group">
          <label className="expert-form__label">Call join URL</label>
          <div className="expert-form__input-wrapper expert-form__input-wrapper--label">
            <a href={schedule.zoomMeeting.join_url}>
              Click here to join as "Atheneum Guest"
            </a>
          </div>
        </div>

        <div className="expert-form__input-group">
          <label className="expert-form__label">Call created at</label>
          <div className="expert-form__input-wrapper expert-form__input-wrapper--label">
            {formatDateTime(schedule.zoomMeeting.created_at)}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      schedule,
      userStore,
      openModalOnClose,
      matchedZoomMeetings
    } = this.props

    return (
      <div className='invite-expert expert-form'>
        {this.renderLoader()}
        {this.renderTitle({ schedule, openModalOnClose })}
        <hr className='hr-separator hr-separator--light hr-separator--large-margin' />
        <div>
          {Boolean(matchedZoomMeetings.length) && (
            <div>
              <InfoBox>
                We found existing zoom meetings in the same period. Select one
                of them to attach this Expert to existing meeting and click
                attach, or choose "create new meeting".
              </InfoBox>

              <div>
                {matchedZoomMeetings.map(meeting => (
                  <div>
                    <RadioButton
                      label={`
                      ${meeting.expertNames} -
                      ${moment(schedule.startTime).format(
                        'DD MMM YYYY. HH:mm'
                      )}`}
                      checked={this.state.zoomMeeting === meeting.id}
                      onClick={() => this.setState({ zoomMeeting: meeting.id })}
                    />
                  </div>
                ))}
                <RadioButton
                  label='Create new meeting'
                  checked={!this.state.zoomMeeting}
                  onClick={() => this.setState({ zoomMeeting: null })}
                />
              </div>
            </div>
          )}
        </div>
        {!matchedZoomMeetings.length || !this.state.zoomMeeting ? (
          <div>
            <Formik
              initialValues={this.getInitialFormValues()}
              validationSchema={this.getFormValidationSchema()}
              onSubmit={this.sumbmitMeetingForm}
              render={form => (
                <Form onSubmit={form.handleSubmit}>
                  <FormLoader loading={form.isSubmitting} />
                  <FormError error={this.state.error} />

                  <Field name='topic' label='Topic' component={Input} />

                  {this.renderMeetingInfo(schedule)}
                  {this.renderUserInfo(schedule, userStore.user)}
                  {this.renderMeetingPassword()}

                  <div className='expert-form__section m-t-lg p-b-0'>
                    <Button primary submit disabled={form.isSubmitting}>
                      Confirm
                    </Button>
                    <Button
                      onClick={this.returnToScheduleModal}
                      disabled={form.isSubmitting}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            />
          </div>
        ) : (
          <div className='expert-form__section m-t-lg p-b-0'>
            <Button primary onClick={this.attachZoomMeeting}>
              Attach
            </Button>
            <Button onClick={this.returnToScheduleModal}>Cancel</Button>
          </div>
        )}
      </div>
    )
  }
}

const RadioButton = ({ label, onClick, checked }) => (
  <div className='radio-button-input' onClick={onClick}>
    <Radio checked={checked} />
    <label>{label}</label>
  </div>
)

export default inject('modalStore', 'userStore', 'growlStore')(
  observer(ZoomMeeting)
)
